import { Center, Text } from "@chakra-ui/react";
import { TargetPersonaWebVisits } from "@intentsify/types";
import { Table } from "components";
import { useMemo } from "react";
import { useWebVisits } from "../BuyingGroup.requests";
import { columns } from "./WebVisitsTable.utils";

type WebVisitsTableProps = {
  campaignId: number;
  accountId: number;
  selectedPersonas: string[];
};
const WebVisitsTable = ({
  campaignId,
  accountId,
  selectedPersonas,
}: WebVisitsTableProps) => {
  const { data: webVisitsData = [] } = useWebVisits({ campaignId, accountId });

  const filteredWebVisits = useMemo(() => {
    if (selectedPersonas.length > 0) {
      return webVisitsData?.filter((visit) =>
        selectedPersonas.includes(`${visit.jobLevel}, ${visit.jobFunction}`)
      );
    }
    return webVisitsData;
  }, [webVisitsData, selectedPersonas]);

  if (filteredWebVisits.length === 0) {
    return (
      <Center p={8}>
        <Text fontWeight={"semibold"}>No web visits found</Text>
      </Center>
    );
  }

  return (
    <Table<TargetPersonaWebVisits>
      stretch
      maxWidth="100%"
      columns={columns}
      data={filteredWebVisits}
      defaultSort={[{ id: "personaName", desc: false }]}
      isScrollable={false}
      isControlledByAPI={false}
    />
  );
};

export { WebVisitsTable };
